import { cn } from "@tine/designsystem-utils";
import type { PropsWithChildren } from "react";

type WhiteSheetProps = {
   className?: string;
   padding?: "sm" | "md" | "lg" | "none";
};

const WhiteSheet = ({ className = "", padding = "md", children }: PropsWithChildren<WhiteSheetProps>) => {
   const whiteSheet = "bg-surface-default basis-0 rounded-md";

   const sheetPadding = {
      sm: "p-4",
      md: "p-6",
      lg: "p-8",
      none: ""
   }[padding];

   return <div className={cn(className, whiteSheet, sheetPadding)}>{children}</div>;
};

export default WhiteSheet;
